import { 
  RECEIVE_JOURNEYS,
  RECEIVE_JOURNEY_STEPS,
  REQUEST_JOURNEYS,
  RECEIVE_JOURNEYS_FAILED,
  SET_KIOSK_MODE
} from '../constants/journey-constants'

import {
  RECEIVE_ARTWORK,
} from '../constants/artwork-constants'

import {
  RESET_INACTIVITY_TIMER
} from '../constants/util-constants'

import {
  WORKER_UPDATE,
  POP_FETCH_QUEUE,
  REGISTER_WORKER,
  WORKER_CLAIM_TASK
} from '../constants/worker-constants'

import Immutable from 'immutable'
import moment from 'moment'

const Journey = Immutable.Record({
  id: null,
  title: "",
  description: "",
  is_published: null,
  created_at: null,
  updated_at: null,
  account_id: null,
  journey_icon: Immutable.fromJS({ url: "" }),
  journey_image: Immutable.fromJS({ url: "" }),
  animated_cover: Immutable.fromJS({ url: "" }),
  adult: false,
  journey_step_ids: Immutable.List()
})

const JourneyStep = Immutable.Record({
  id: null,
  journey_id: null,
  name: "",
  description: "",
  priority: null,
  created_at: null,
  updated_at: null,
  art_piece_ids: Immutable.List()
})

const Artwork = Immutable.Record({
  id: null,
  title: "",
  artist: "",
  artist_dates: "",
  year: "",
  description: "",
  pdf_blurb: "", // deprecated?
  created_at: null,
  updated_at: null,
  account_id: null,
  artwork: Immutable.fromJS({
    url: "",
    small: {url: ""},
    medium: {url: ""},
    large: {url: ""},
  }),
  "orientation": "", // landscape or portrait
  "origin": "", // deprecated?
  "materials": "",
  "credit_line": "",
  "copyright": "", // deprecated?
  "look_again": "", // deprecated?
  "gallery_id": null,
  "accession_number": ""
})

const initialState = Immutable.fromJS({
  // static assets
  journeysById: Immutable.Map(),
  journeySteps: Immutable.fromJS({
    byId: Immutable.Map(),
    allIds: Immutable.List()
  }),
  isFetching: {
    journeys: false,
    artwork: false,
  },
  fetchQueue: Immutable.fromJS({
    queue: Immutable.List(),
    workerStatus: Immutable.List(),
  }),
  artworkById: Immutable.Map(),
  kioskMode: false,
  lastGlobalClick: moment.now(), // last time of a click on top or bottom (global reset timer)
});

// take a deep javascript object and map it to Immutable.Map
const listToMapById = (data, obj, sort = (o => o.title)) => {
  return Immutable.Map(data.map( o => [o.id, new obj(Immutable.fromJS(o))])).sortBy(sort)
}

export default (state = initialState, action) => {
  const { workerId, status, task } = action.payload ? action.payload : {}
  let workerTask, newWorkerTask, newworkerStatus
  let queue = state.getIn(['fetchQueue', 'queue'])

  switch (action.type) {
    case REQUEST_JOURNEYS:
      return (state.withMutations(s => {s
        .setIn(['isFetching', 'journeys'], true)}))
    case RECEIVE_JOURNEYS:
      const journeys = listToMapById(action.payload.data, Journey)
      queue = queue.concat(journeys.map(j => j.getIn(['animated_cover', 'url'])))
      return state.withMutations(s => {
        s.set('journeysById', journeys)
        s.setIn(['isFetching', 'journeys'], false)
        s.setIn(['fetchQueue', 'queue'], queue)
      })
    case RECEIVE_JOURNEYS_FAILED:
       console.log('Receive Journeys Failed')
       return state.setIn(['isFetching', 'journeys'], false)
    case RECEIVE_ARTWORK:
      // queue up the artwork fetching
      const artwork = listToMapById(action.payload.data, Artwork)

      // queue up the artwork for prefetch
      queue = queue.concat(artwork.map(a => a.getIn(['artwork', 'medium', 'url'])))
      queue = queue.concat(artwork.map(a => a.getIn(['artwork', 'small', 'url'])))
      queue = queue.concat(artwork.map(a => a.getIn(['artwork', 'large', 'url'])))

      return state.withMutations(s => {
        s.set('artworkById', artwork)
        s.setIn(['fetchQueue', 'queue'], queue)
      })
    case RECEIVE_JOURNEY_STEPS:
      return state.withMutations(s => {
        const steps = listToMapById(action.payload.data, JourneyStep, o => o.priority)
        s.setIn(['journeySteps', 'byId'], steps)
        .setIn(['journeySteps', 'allIds'], steps.keySeq()) // list of ids, sorted by priority
      })

    /* Prefetch Worker Reducers */
    case POP_FETCH_QUEUE:
      // remove a single item from the queue
      return state.setIn(['fetchQueue', 'queue'], state.getIn(['fetchQueue', 'queue']).shift())
    case WORKER_UPDATE:
      // set worker status and
      workerTask = state.getIn(['fetchQueue', 'workerStatus']).get(workerId)
      newWorkerTask = workerTask.set('status', status).set('task', task)
      newworkerStatus = state.getIn(['fetchQueue', 'workerStatus']).set(workerId, newWorkerTask)
      return state.setIn(['fetchQueue', 'workerStatus'], newworkerStatus)
    case WORKER_CLAIM_TASK:
      // set worker status and
      workerTask = state.getIn(['fetchQueue', 'workerStatus']).get(workerId)
      newWorkerTask = workerTask.set('status', status)
      newworkerStatus = state.getIn(['fetchQueue', 'workerStatus']).set(workerId, newWorkerTask)
      return state.setIn(['fetchQueue', 'workerStatus'], newworkerStatus)
    case REGISTER_WORKER:
      // register worker with workerId
      newWorkerTask = Immutable.fromJS({status: 'idle', 'task': null})
      newworkerStatus = state.getIn(['fetchQueue', 'workerStatus']).set(workerId, newWorkerTask)
      return state.setIn(['fetchQueue', 'workerStatus'], newworkerStatus)
    case SET_KIOSK_MODE:
      return state.setIn(['kioskMode'], action.payload.kioskMode)
    case RESET_INACTIVITY_TIMER:
      return state.set('lastGlobalClick', moment.now())
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/journey-reducers.js